/*global define:false*/
define('addAssetsViewConfig',['addAssetsViewModel'], function (addAssetsViewModel) {
    'use strict';

    return {
        name : 'addAssetsView',
        ModelType : addAssetsViewModel,
        modelData : {},
        listeners : [],
        events : {},
        permissions : ['admin', 'editor']
    };
});

